import { Marked } from "marked";

/**
 * A marked instance configured to strip raw HTML from markdown source before
 * rendering. This is edge-runtime safe (pure JS, no DOM required) and blocks
 * the primary stored-XSS vector — inline <script>, event handlers, iframes,
 * etc. — should admin-authored content ever contain untrusted HTML.
 */
const marked = new Marked({
  async: false,
  gfm: true,
  breaks: false,
});

// Discard any raw block/inline HTML tokens the parser produces so nothing
// user-controlled reaches the final HTML string. Standard markdown constructs
// (headings, lists, links, code, images, tables) are unaffected.
marked.use({
  walkTokens(token) {
    if (token.type === "html" || (token as any).type === "tag") {
      (token as any).type = "text";
      (token as any).text = "";
      (token as any).raw = "";
    }
  },
});

export function renderSafeMarkdown(md: string): string {
  return marked.parse(md ?? "", { async: false }) as string;
}